import { Collapse, List, ListItem, Typography } from '@mui/material';

import clsx from 'clsx';
import styled from 'styled-components';

import { MobileInnerProps } from './types';

const StyledNestedList = styled(List)`
  &.nested-list {
    span.nav-item-nested-menu-item {
      cursor: default;
    }
  }
`;

export const MobileNavInner = ({ open, subItems, onSubItemClick }: MobileInnerProps) => {
  return (
    <Collapse in={open} timeout="auto" orientation="vertical" unmountOnExit>
      <StyledNestedList className="nested-list" disablePadding>
        {subItems.map((item, index) => {
          let listItemProps;
          if (item.isExternal && item.path) {
            // Currently only support one level down navigation
            listItemProps = {
              component: 'a',
              href: item.path,
              target: '_blank',
              rel: 'noopener noreferrer',
            };
          }
          // Only support single level dropdowns for now
          return (
            <ListItem
              {...item.buttonProps}
              {...listItemProps}
              key={index}
              className={clsx('nav-item-menu-item', 'nav-item-nested-menu-item')}
            >
              <Typography className="nav-item-inner" variant="h6" component="span" onClick={onSubItemClick}>
                {item.text}
              </Typography>
            </ListItem>
          );
        })}
      </StyledNestedList>
    </Collapse>
  );
};
